import { Tooltip } from '@aimsos/ui';
import InboxChip from './InboxChip.jsx';

/**
 * "+N" overflow indicator with a tooltip listing the hidden items.
 * Meeting-agreed delta from the prototype: the +N must reveal what it hides.
 */
function OverflowTagsTooltip({ items = [] }) {
  if (!items.length) return null;
  return (
    <Tooltip
      size="compact"
      position="top"
      align="start"
      arrow={false}
      content={
        <ul className="space-y-0.5">
          {items.map((item, index) => (
            <li key={`${index}-${item}`}>{item}</li>
          ))}
        </ul>
      }
    >
      <InboxChip>+{items.length}</InboxChip>
    </Tooltip>
  );
}

export default OverflowTagsTooltip;
